import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const voidObject = {};

class JourneyList extends React.Component {
  isTitleRow = (index) => {
    const { grouped } = this.props;
    const { date } = grouped[index] || voidObject;
    return !!date;
  };

  renderTitleRow = (index) => {
    const { grouped, titleComponent: Title } = this.props;
    const { date, numberOfItemsByDate } = grouped[index] || voidObject;
    return <Title date={date} key={date} numberOfItems={numberOfItemsByDate} />;
  };

  renderJourneyRow = (index) => {
    const { grouped, onCardClick, cardComponent: Card } = this.props;
    const { id } = grouped[index] || voidObject;
    if (!id) {
      return null;
    }

    return <Card journeyId={id} key={id} onClick={onCardClick} />;
  };

  renderRow = (index) => {
    if (this.isTitleRow(index) && !this.props.hideTitle) {
      return this.renderTitleRow(index);
    }
    return this.renderJourneyRow(index);
  };

  renderLoading = () => {
    const { loadingComponent: Loading } = this.props;
    return <Loading />;
  };

  render() {
    const {
      className,
      grouped,
      titleComponent: Title,
      cardComponent: Card,
      onCardClick,
      hideTitle = false,
    } = this.props;

    return (
      <div className={className}>
        {Object.keys(grouped).map((groupKey) => (
          <Fragment key={groupKey}>
            {!hideTitle && <Title date={groupKey} numberOfItems={0} />}
            {grouped[groupKey].map((journeyId) => (
              <Card journeyId={journeyId} key={journeyId} onClick={onCardClick} />
            ))}
          </Fragment>
        ))}
      </div>
    );
  }
}

JourneyList.propTypes = {
  grouped: PropTypes.shape({}),
  titleComponent: PropTypes.elementType.isRequired,
  loadingComponent: PropTypes.elementType.isRequired,
  cardComponent: PropTypes.elementType.isRequired,
  onCardClick: PropTypes.func,
  className: PropTypes.string,
};

JourneyList.defaultProps = {
  grouped: {},
};

export default JourneyList;
